function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["isMulti", "customComponents", "isCheckbox", "isCheckboxOnGroupHeading", "onApply", "onChange", "onMenuClose", "onOutsideClick", "value", "isMenuVisibleOnFocus", "noInteractionBorder"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React, { useState, useEffect } from "react";
import { bool, func, string } from "prop-types";
import { components } from "react-select";
import { Select } from "#library/components/SelectFilter/Select/Select";
import { selectTypes } from "#library/components/SelectFilter/Select/types/types";
import { MenuList, MenuListTags, MenuListCheckbox, ValueContainerMulti, ClearIndicator, IndicatorsContainer, GroupHeadingCheckbox, Option, OptionCheckbox, GroupCheckbox } from "#library/components/SelectFilter/customComponents";

// TODO: the filter placeholder container wraps when the filter width is too small, creating some weird UI,
// we need to find a solution to avoid having issues when this component has a small width

// TODO: We could improve the accessibility for the component :
// * Possible to focus the "X" to clear selected labels but not possible to validate it with keyboard (enter, space, ...)
// * When the dropdown is open it is not possible to go to "Clear" or "Apply" with keyboard. Tab key is used to select checkbox inside dropdown
export var Filter = function Filter(props) {
  var _props$isMulti = props.isMulti,
    isMulti = _props$isMulti === void 0 ? false : _props$isMulti,
    customComponents = props.customComponents,
    _props$isCheckbox = props.isCheckbox,
    isCheckbox = _props$isCheckbox === void 0 ? false : _props$isCheckbox,
    _props$isCheckboxOnGr = props.isCheckboxOnGroupHeading,
    isCheckboxOnGroupHeading = _props$isCheckboxOnGr === void 0 ? true : _props$isCheckboxOnGr,
    _onApply = props.onApply,
    _onChange = props.onChange,
    _onMenuClose = props.onMenuClose,
    onOutsideClick = props.onOutsideClick,
    value = props.value,
    _props$isMenuVisibleO = props.isMenuVisibleOnFocus,
    isMenuVisibleOnFocus = _props$isMenuVisibleO === void 0 ? false : _props$isMenuVisibleO,
    _props$noInteractionB = props.noInteractionBorder,
    noInteractionBorder = _props$noInteractionB === void 0 ? false : _props$noInteractionB,
    restProps = _objectWithoutProperties(props, _excluded);
  // eslint-disable-next-line no-nested-ternary
  var _useState = useState(value || (isMulti ? [] : undefined)),
    _useState2 = _slicedToArray(_useState, 2),
    backupValue = _useState2[0],
    setBackupValue = _useState2[1];
  var _useState3 = useState(backupValue),
    _useState4 = _slicedToArray(_useState3, 2),
    currentValue = _useState4[0],
    setCurrentValue = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    hasApplied = _useState6[0],
    setHasApplied = _useState6[1];
  useEffect(function () {
    var newValue = value || (isMulti ? [] : undefined);
    setBackupValue(newValue);
    setCurrentValue(newValue);
  }, [value, isMulti]);
  return /*#__PURE__*/React.createElement(Select, _extends({
    isMulti: isMulti,
    value: currentValue,
    customComponents: _objectSpread({
      IndicatorsContainer: isMulti ? IndicatorsContainer : components.IndicatorsContainer,
      ClearIndicator: isMulti ? function () {
        return null;
      } : ClearIndicator,
      MenuList: isMulti ? isCheckbox ? MenuListCheckbox : MenuListTags : MenuList,
      ValueContainer: isMulti ? ValueContainerMulti : components.ValueContainer,
      GroupHeading: isCheckbox && isCheckboxOnGroupHeading ? GroupHeadingCheckbox : components.GroupHeading,
      Option: isCheckbox ? OptionCheckbox : Option,
      Group: isCheckbox ? GroupCheckbox : components.Group
    }, customComponents),
    closeMenuOnSelect: !isMulti,
    hideSelectedOptions: !isCheckbox,
    isCheckbox: isCheckbox,
    onMenuOpen: function onMenuOpen() {
      setHasApplied(false);
    },
    onMenuClose: function onMenuClose() {
      setCurrentValue(backupValue);
      if (_onMenuClose) {
        _onMenuClose(currentValue);
      }
      if (!hasApplied && onOutsideClick) {
        onOutsideClick(currentValue);
      }
    },
    onApply: function onApply(nextValue) {
      setHasApplied(true);
      setBackupValue(nextValue);
      if (_onApply) {
        _onApply(nextValue);
      }
    },
    onChange: function onChange(nextValue, triggeredAction) {
      setCurrentValue(nextValue);
      if (!isMulti) {
        setBackupValue(nextValue);
        if (_onApply) {
          _onApply(nextValue);
        }
      }
      if (_onChange) {
        _onChange(nextValue, triggeredAction);
      }
    },
    isMenuVisibleOnFocus: isMenuVisibleOnFocus,
    noInteractionBorder: noInteractionBorder
  }, restProps));
};
Filter.propTypes = _objectSpread(_objectSpread({}, selectTypes), {}, {
  clearLabel: string,
  applyLabel: string,
  selectAllLabel: string,
  indicatorClearLabel: string,
  isCheckbox: bool,
  isCheckboxOnGroupHeading: bool,
  isMulti: bool,
  leftIconId: string,
  hideIndicatorOnSingleSelection: bool,
  displayValueOnSingleSelection: bool,
  onApply: func,
  onOutsideClick: func,
  onChange: func
});